import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../Pricing.css';
import UserStatus from './UserStatus';
import API from '../api';


function Pricing() {
    const { user } = useAuth();
    const [data, setData] = useState([]);
    const [deleted, setDeleted] = useState(true);
    const navigate = useNavigate();



const plans = [
 {
    id: 1,
    name: 'Free Trial',
    price: 'Free',
    features: ['For up to 3 stocks', 'Telegram Notification', 'Price, % Change and News Notification',  'Free for 14 days'],
    button: 'Start Free Trial',
    link: '/signup'
  },
  {
    id: 2,
    name: 'Silver',
    price: 'Tk 300/month',
    features: ['For up to 5 stocks', 'Telegram / SMS Notification', 'Price, % Change and News Notification', 'Billed Monthly'],
    button: 'Choose Silver',
    link: '/signup'
  },
  {
    id: 3,
    name: 'Gold',
    price: 'Tk 500/month',
    features: ['For up to 10 stocks', 'Telegram / SMS Notification', 'Price, % Change and News Notification', 'Billed Monthly'],
    button: 'Choose Gold',
    link: '/signup'
  }, 
  {
    id: 4,
    name: 'Platinum',
    price: 'Tk 1000/month',
    features: ['For 25 stocks', 'Telegram / SMS Notification', 'Price, % Change and News Notification', 'Billed Monthly'],
    button: 'Choose Platinum',
    link: '/signup'
  }
];

useEffect(() => {
  document.title = "Pricing | TradeBarta.com";
}, []);

const handlePlanClick = (plan) => {
  if (!user) {
    navigate('/signup', { state: { selectedPlan: plan } });
  } else {
    
    if (plan.name === 'Free Trial') {
      navigate('/Dashboard');
    } else {
      navigate('/payment', { state: { selectedPlan: plan } });
    }
  }
};

  return (
    <div className="page-container">
      <div className="content-wrap">
  <section className="navbar-area navbar-one">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <nav className="navbar navbar-expand-lg">
            <a className="navbar-brand" href="/">
              <img width = "200" height = "70" src={require("../images/logo.png")} alt="Logo" />
            </a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarOne"
              aria-controls="navbarOne" aria-expanded="false" aria-label="Toggle navigation">
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
              <ul className="navbar-nav m-auto">
            <li className="nav-item">
                  <a className="page-scroll" href="/">Home</a>
                </li>
                <li className="nav-item">
                  <a className="active page-scroll" href="/pricing">Pricing</a>
                </li>                
                <li className="nav-item">
                  <a className="page-scroll" href="/referral">Refer and Win</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/faq">FAQ</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/contact">Contact Us</a>
                </li>
              </ul>
            </div>
        
            <div className="navbar-btn">
                 <UserStatus />       
            </div>
          </nav>
        </div>
      </div>
    </div>
  </section>

    <div className="pricing-container">
      <h1>Choose Your Plan</h1>
      <div className="pricing-cards">
        {plans.map((plan, index) => (
          <div className="pricing-card" key={index}>
            <h2>{plan.name}</h2>
            <p className="price">{plan.price}</p>
            <ul>
              {plan.features.map((feature, i) => (
                <li key={i}>{feature}</li>
              ))}
            </ul>
            <button className="btn" onClick={() => handlePlanClick(plan)}>
              {plan.button}
            </button>
          </div>
        ))}
      </div>
    </div>
</div>
<section className="footer-area footer-five">
  <div className="container">
    <div className="footer-top-content">
      
      {/* Links Section */}
      <div className="footer-links">
        <ul>
          <li>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>
          </li>
          <li>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>

      {/* Contact Section */}
      <div className="footer-contact">
        <h4>Contact Us:</h4>
        <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>
      </div>

    </div>
  </div>

  {/* Bottom copyright section */}
  <div className="footer-copyright">
    <div className="container">
      <p className="text-center">Copyright © 2025. All Rights Reserved</p>
    </div>
  </div>
</section>
</div>
)
}

export default Pricing